import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';
import { HashLink as Link } from 'react-router-hash-link';

import ArrowCircleImg from '../../assets/icons/arrow-circle-empty-black.svg';
import ArrowCircleImgContrast from '../../assets/icons/arrow-circle-empty-right-contrast.svg';

const MainPageHeadingsInfo = ({ clang, data }) => {

    return (
        <article className="main-info">
            <div className="main-info__circle">
                <div className="main-info__circle-left"></div>
                <div className="main-info__circle-inner"></div>
                <div className="main-info__circle-right"></div>
            </div>
            <div className="main-info__container">
                <p className="main-info__title">
                    {lang[clang].main_page.browse_headings}
                </p>
                <ul className="main-info__list">
                    {data.map((dataItem, index) =>
                        <li key={index} className="main-info__list-item">
                            <div className="main-info__box-separator"></div>
                            <div className="main-info__box-data">
                              <Link to={`/headings/about#${[dataItem.domainCode]}`} title={lang[clang].main_page[dataItem.domainCode]} 
                              className="main-info__box-data--link" scroll={el => el.scrollIntoView({ block: 'start' })}>
                                {lang[clang].main_page[dataItem.domainCode]}
                                 <span className="main-info__box-data--link-line"></span>
                                 <img className="main-info__box-data--link-img" src={ArrowCircleImg} alt="" />
                                 <img className="main-info__box-data--link-img contrast" src={ArrowCircleImgContrast} alt=""/>
                                 <div className="main-info__box-data--number">{!!dataItem.recordsNumber ? numberWithSpaces(dataItem.recordsNumber) : 0}</div>
                                 <div className="main-info__box-data--desc">{lang[clang].main_page.records_headings}</div>
                               </Link>
                            </div>
                        </li>)}
                </ul>
            </div>

        </article>
    );
};

MainPageHeadingsInfo.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(MainPageHeadingsInfo);



// WEBPACK FOOTER //
// ./src/components/main-page/MainPageHeadingsInfo.js